export default [
  {
    name: 'default',
    path: '/',
    redirect: 'dashboard',
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@pages/Dashboard'),
    meta: { title: 'v2.fm.menu.dashboard', requiresAuth: true, icon: 'home' },
  },
  {
    name: 'diagnostics',
    path: '/diagnostics',
    component: () => import('@pages/Diagnostics'),
    meta: { title: 'v2.fm.menu.monitor', requiresAuth: true, icon: 'timeline' },
  },
  {
    name: 'location',
    path: '/location',
    component: () => import('@pages/DevicesLocation'),
    meta: { title: 'v2.fm.menu.devices-localization', requiresAuth: true, icon: 'map' },
  },
  {
    path: '/alerts',
    component: () => import('@pages/Alerts'),
    meta: { title: 'v2.fm.menu.alerts', requiresAuth: true, icon: 'notifications' },
    children: [
      { path: '', redirect: 'alert-rules' },
      {
        name: 'alerts-list',
        path: 'list',
        component: () => import('@components/domains/device/List/AlertList/AlertList.vue'),
        meta: { title: 'v2.fm.menu.alert-list', requiresAuth: true },
      },
      {
        name: 'alert-rules',
        path: 'alert-rules',
        component: () => import('@pages/Alerts/AlertRules'),
        meta: { title: 'v2.fm.menu.alert-rules', requiresAuth: true },
      },
      {
        name: 'alert-rule',
        path: 'alert-rule/:id',
        component: () => import('@pages/Alerts/AlertRule'),
        meta: { title: 'v2.fm.menu.alert-rule', requiresAuth: true },
        props: true,
      },
    ],
  },
  {
    name: 'production',
    path: '/production',
    component: () => import('@pages/Production'),
    meta: {
      title: 'v2.fm.menu.production',
      requiresAuth: true,
      icon: 'description',
    },
  },
  {
    name: 'reports',
    path: '/reports',
    component: () => import('@pages/Reports'),
    meta: { title: 'v2.fm.menu.reports-cyclic', requiresAuth: true, icon: 'description' },
  },
  {
    name: 'reports-list',
    path: '/reports-list',
    component: () => import('@pages/ReportsList'),
    meta: {
      title: 'v2.fm.menu.reports-list',
      requiresAuth: true,
      icon: 'description',
    },
  },
  {
    name: 'brain-reports',
    path: '/brain',
    component: () => import('@pages/Brain'),
    meta: {
      title: 'v2.fm.menu.brain',
      requiresAuth: true,
      icon: 'brain',
    },
  },
  {
    name: 'brain-report-details',
    path: '/brain/:id',
    component: () => import('@pages/Brain/BrainReportDetails.vue'),
    meta: {
      title: 'v2.fm.menu.brain',
      requiresAuth: true,
      icon: 'brain',
    },
    props: true,
  },
  {
    path: '/manage',
    component: () => import('@pages/Manage/Manage'),
    meta: { title: 'v2.fm.menu.manage', requiresAuth: true, icon: 'settings' },
    children: [
      {
        name: 'devices',
        path: 'devices',
        component: () => import('@pages/Manage/Devices'),
        meta: { title: 'v2.fm.menu.devices', requiresAuth: true },
      },
      {
        name: 'device',
        path: 'device/:id',
        component: () => import('@pages/Manage/Devices/Device'),
        meta: { title: 'v2.fm.menu.device-details', requiresAuth: true },
        props: true,
      },
      {
        name: 'device-groups',
        path: 'device-groups',
        component: () => import('@pages/Manage/DeviceGroups'),
        meta: { title: 'v2.fm.menu.device-groups', requiresAuth: true },
      },
      {
        name: 'device-group',
        path: 'device-group/:id',
        component: () => import('@pages/Manage/DeviceGroups/DeviceGroup'),
        meta: { title: 'v2.fm.menu.device-group-details', requiresAuth: true },
        props: true,
      },
      {
        name: 'device-operators',
        path: 'device-operators',
        component: () => import('@pages/Manage/Workers'),
        meta: { title: 'v2.fm.menu.device-operators', requiresAuth: true },
      },
      {
        name: 'device-operator',
        path: 'device-operator/:id',
        component: () => import('@pages/Manage/Workers/Worker'),
        meta: { title: 'v2.fm.menu.device-operator-details', requiresAuth: true },
        props: true,
      },
      {
        name: 'device-operator-groups',
        path: 'device-operator-groups',
        component: () => import('@pages/Manage/WorkerGroups'),
        meta: { title: 'v2.fm.menu.device-operator-groups', requiresAuth: true },
      },
      {
        name: 'device-operator-group',
        path: 'device-operator-groups/:id',
        component: () => import('@pages/Manage/WorkerGroups/WorkerGroup'),
        meta: { title: 'v2.fm.menu.device-operator-group-details', requiresAuth: true },
        props: true,
      },
    ],
  },
  {
    name: 'users',
    path: '/users',
    component: () => import('@pages/Users'),
    meta: { title: 'v2.fm.menu.users', requiresAuth: true },
  },
  {
    path: '/administration',
    component: () => import('@pages/Administration/Administration'),
    meta: { title: 'v2.fm.menu.administration', requiresAuth: true },
    children: [
      {
        name: 'administration-devices',
        path: 'devices',
        component: () => import('@pages/Administration/Devices'),
        meta: { title: 'v2.fm.menu.administration-device', requiresAuth: true },
      },
      {
        name: 'administration-sensors',
        path: 'sensors',
        component: () => import('@pages/Administration/Sensors'),
        meta: { title: 'v2.fm.menu.administration-sensors', requiresAuth: true },
      },
      {
        name: 'administration-users',
        path: 'users',
        component: () => import('@pages/Administration/Users'),
        meta: { title: 'v2.fm.menu.administration-users', requiresAuth: true },
      },
      {
        name: 'administration-user-groups',
        path: 'user-groups',
        component: () => import('@pages/Administration/UserGroups'),
        meta: { title: 'v2.fm.menu.administration-user-groups', requiresAuth: true },
      },
      {
        name: 'administration-subscribers',
        path: 'subscribers',
        component: () => import('@pages/Administration/Subscribers'),
        meta: { title: 'v2.fm.menu.administration-subscribers', requiresAuth: true },
      },
      {
        name: 'administration-devices-types',
        path: 'devices-types',
        component: () => import('@pages/Administration/DevicesTypes'),
        meta: { title: 'v2.fm.menu.administration-devices-types', requiresAuth: true },
      },
    ],
  },
];
